import { render, staticRenderFns } from "./PapaMergeQuestion.vue?vue&type=template&id=4a5c4d61&scoped=true"
import script from "./PapaMergeQuestion.vue?vue&type=script&lang=js"
export * from "./PapaMergeQuestion.vue?vue&type=script&lang=js"
import style0 from "./PapaMergeQuestion.vue?vue&type=style&index=0&id=4a5c4d61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c4d61",
  null
  
)

export default component.exports